module.exports = __webpack_public_path__ + "img/30.b9b98ee4.png";